import { createSelector } from 'reselect';

const selectDesignations = (state: any) => state.designations;


export const selectCurrentItem = createSelector([selectDesignations], (designations) => designations.current);

export const selectListItems = createSelector([selectDesignations], (designations) => designations.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectDesignations], (designations) => designations.create);

export const selectUpdatedItem = createSelector([selectDesignations], (designations) => designations.update);

export const selectReadItem = createSelector([selectDesignations], (designations) => designations.read);

export const selectDeletedItem = createSelector([selectDesignations], (designations) => designations.delete);

export const selectSearchedItems = createSelector([selectDesignations], (designations) => designations.search);

export const selectItemsCount = createSelector([selectDesignations], (designations) => designations.count);

export const selectItemsFilter = createSelector([selectDesignations], (designations) => designations.filter);